import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { Meta } from '@angular/platform-browser';

const BASE_URL = 'https://soyiphone.com.ar';

// Setea <link rel="canonical"> (crea el tag si no existe) y og:url para la
// ruta actual. Evita contenido duplicado entre /lista?seccion=X y query
// params espurios (?v=4, etc.) que no aportan una URL "canónica" distinta.
@Injectable({ providedIn: 'root' })
export class SeoService {
  constructor(@Inject(DOCUMENT) private doc: Document, private meta: Meta) {}

  // `path` es la ruta absoluta desde la raíz, con el query string relevante
  // ya armado si corresponde (ej. '/lista?seccion=Nuevos').
  setCanonicalUrl(path: string): void {
    const url = `${BASE_URL}${path}`;
    let link = this.doc.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
    }
    link.setAttribute('href', url);
    this.meta.updateTag({ property: 'og:url', content: url });
  }

  // og:title/og:description arrancan con el texto genérico de index.html
  // (mismo en las 4 páginas) — esto les pisa el texto real de cada página,
  // para que compartir un link puntual (no solo la home) por WhatsApp/
  // Instagram muestre la vista previa que corresponde. La imagen (og:image)
  // se deja igual en todas a propósito: una sola portada de marca, no hay
  // foto específica por página que tenga sentido usar ahí.
  setSocial(title: string, description: string): void {
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
  }

  // Precarga una imagen que se pinta vía CSS background-image (el navegador
  // recién la descubre cuando termina de parsear el CSS, y para el LCP eso
  // es tarde) — `media` opcional deja que el navegador elija sola la que
  // corresponde al viewport, igual que un <picture>.
  preloadImage(href: string, media?: string): void {
    const link = this.doc.createElement('link');
    link.setAttribute('rel', 'preload');
    link.setAttribute('as', 'image');
    link.setAttribute('href', href);
    link.setAttribute('fetchpriority', 'high');
    if (media) link.setAttribute('media', media);
    this.doc.head.appendChild(link);
  }

  // Crea o actualiza un <script type="application/ld+json" id="...">. `id`
  // separa este bloque del ElectronicsStore fijo que ya vive en index.html.
  setJsonLd(id: string, data: unknown): void {
    if (!this.doc || !this.doc.head) return;
    let script = this.doc.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = this.doc.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      this.doc.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
  }
}
